import '../../styles/ServiceFeature.css';

type card = {
  title: string;
  description: string;  
  features?: string[];
};

type ServiceFeatureProps = {
  sectionHeading: string;
  content: card[];
};

const ServiceFeature: React.FC<ServiceFeatureProps> = ({ sectionHeading, content }) => {
  return (
    <section className="serviceFeature-section">
        <div className='serviceFeature-content'>
            <p className="sections-title">{sectionHeading}</p>
            <div className="serviceFeature-container">
            {content.map((card, index) => (
              <div key={index} className="serviceFeature-card">
                <div className="use-case-content">
                  <div>
                    <h3 className="use-case-title">{card.title}</h3>
                    <p className="use-case-description">{card.description}</p>
                  </div>
                  <div className="all-features-row">
                  {card.features && card.features.length > 0 && (
                    <ul className="use-case-features">
                      {card.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="use-case-feature">
                          {feature}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
    </section>
  );
};

export default ServiceFeature;